// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root__2OilP","modalContent":"styles__modalContent__1hGqE","modalTitle":"styles__modalTitle__STLJz","modalMessage":"styles__modalMessage__1nGqB","modalButtonOk":"styles__modalButtonOk__1QPFl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfileCompletionModal/styles.css
// module id = 2060
// module chunks = 0